import PropTypes from 'prop-types'
import { Dialog, Stack, Button } from '@chakra-ui/react'

export const YesNoPopupModal = ({ title, submitTitle = 'Yes', cancelTitle = 'No', handleSubmit, handleCancel, isOpen = true }) => (
  <Dialog.Root placement="center" open={isOpen} onOpenChange={(details) => !details.open && handleCancel?.()}>
    <Dialog.Backdrop />
    <Dialog.Positioner>
      <Dialog.Content>
        <Dialog.Body>{title}</Dialog.Body>
        <Dialog.Footer>
          <Stack direction="row" gap={0}>
            <Button onClick={handleCancel}>{cancelTitle}</Button>
            <Button onClick={handleSubmit} ml={4}>
              {submitTitle}
            </Button>
          </Stack>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Positioner>
  </Dialog.Root>
)

YesNoPopupModal.propTypes = {
  title: PropTypes.string.isRequired,
  submitTitle: PropTypes.string,
  cancelTitle: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func,
  isOpen: PropTypes.bool,
}
